import { CSSProperties } from "react";

import { useIntl } from "react-intl";

import { getContentFileName } from "./DisplayContentFile";

type ButtonDownloadFileProps = {
  style?: CSSProperties;
  content: Blob | string;
  contentFile: string;
  contentType: string;
  direction?: CSSProperties["direction"];
  showFileSize?: boolean;
};

const ButtonDownloadFile = (props: ButtonDownloadFileProps) => {
  const intl = useIntl();

  const downloadFile = async (): Promise<void> => {
    const formattedName = decodeURI(props.contentFile.split("?")[0].split("/").pop() || "");
    const filename = getContentFileName(String(props.content)) || formattedName;

    try {
      const response = await fetch(props.contentFile);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = blobUrl;
      a.download = filename;

      document.body.append(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      {props.contentType === "file" && typeof props.content === "string" && props.showFileSize && (
        <div
          style={{
            color: "#085fff",
            cursor: "pointer",
            direction: props.direction || "rtl",
            display: "flex",
            fontSize: "13px",
            margin: "2px 4px 0 0",
            ...props.style,
          }}
          onClick={downloadFile}
        >
          {intl.formatMessage({ id: "download.download" })}
        </div>
      )}
    </>
  );
};

export default ButtonDownloadFile;
